//CONSTS
const apiRef = 'https://shopweruva.myshopify.com/api/2023-04/graphql';
const accessToken = 'bc6966147a5e6a02ee257c3f56f9e611';
//GLOBAL VARS
var variantIdDataElement, quickviewForm, quickfindDealerBtn, quickfindPrice, quickfindBackorder, quickViewDetails;

//REQUEST VARIANT INFO
async function getProductMetafieldInfo(variantId) {
    //HEADERS
    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken
    });
    //VARIANT ID
    var the_var = "gid://shopify/ProductVariant/"+variantId;
    //GRAPHQL QUERY
    const query = `
        {
            node(id: "${the_var}") {
                ... on ProductVariant {
                    title
                    id
                    dtc: metafield(namespace: "custom", key: "dtc") {
                        value
                    }
                }
            }
        }
    `;
    //FETCH
    fetch(apiRef, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        query: query
      }),
    })
    //RESPONSE
    .then((response) => response.json())
        .then((data) => {
        //CHECK IF THE CURRENT IS DTC
        isCurrentDTC(data);
    })
    //ERR
    .catch((err) => {
        console.log("error", err);
    });
}

//CHECKS IF CURRENT IS DTC
function isCurrentDTC(data) {
    var dtcNode = data.data.node.dtc;
    //IF CURRENT IS DTC - THEN SWAP OUT FORM
    if(dtcNode == null) {
        noDTC();
    } else {
        var dtcValue = dtcNode.value;
        //IF DTC PRESENT HIDE OR SHOW
        if (dtcValue === 'true') {
            hasDTC();
        } else {
            noDTC();
        }
    }
}

//OBSERVE MODAL ACTIVATION
function observeModalActivation() {
    const modalProductForm = document.querySelector('quick-add-drawer product-form')

    if (modalProductForm) {
        const observer = new MutationObserver((mutations) => { 
            const newProductForm = mutations[0].addedNodes[0]
            variantIdDataElement = newProductForm.querySelector('quick-add-drawer product-form input[name="id"]');
            if (variantIdDataElement) {
                getProductMetafieldInfo(variantIdDataElement.value);
            }

            // Hide the price element initially before it's added back (if DTC)
            const priceElement = document.querySelector('quick-add-drawer .product-price');
            priceElement.style.display = "none"            
        })

        observer.observe(modalProductForm, { childList: true})
    }
}

//DOM LOADED - START OBSERVING MODAL ACTIVATION
document.addEventListener("DOMContentLoaded", function() {
    observeModalActivation();
});

//UPDATE VARS WHEN WE NEED
function getDTCVars(retryCount = 0) {
    quickviewForm = document.querySelector('quick-add-drawer product-form .pdp-dtc-form');
    quickfindDealerBtn = document.querySelector('quick-add-drawer product-form .update-dtc-var');
    quickfindPrice = document.querySelector('quick-add-drawer .product-price');
    quickfindBackorder = document.querySelector('quick-add-drawer .product-backorder');
    quickViewDetails = document.querySelector('quick-add-drawer .product-view-details');
    if ((!quickviewForm || !quickfindDealerBtn || !quickfindPrice || !quickViewDetails) && retryCount < 3) {
        setTimeout(() => getDTCVars(retryCount + 1), 200);
    } else if (retryCount >= 3) {
        console.error('Some elements not found after multiple retries');
    }
}

//HAS DTC
function hasDTC() {
    getDTCVars();
    //MAKE SURE WE GOT ELEMENTS
    const checkInterval = setInterval(() => {
        if (quickviewForm && quickfindDealerBtn && quickfindPrice) {
            clearInterval(checkInterval);
            // HIDE/SHOW
            quickviewForm.style.display = "block";
            quickfindPrice.style.display = "block";
            quickfindBackorder.style.display = "block";
            quickfindDealerBtn.style.display = "none";
            quickViewDetails.classList.add("show");
        }
    }, 200);
}
//NO DTC
function noDTC() {
    getDTCVars();
    //MAKE SURE WE GOT ELEMENTS
    const checkInterval = setInterval(() => {
        if (quickviewForm && quickfindDealerBtn && quickfindPrice) {
            clearInterval(checkInterval);
            // HIDE/SHOW
            quickviewForm.style.display = "none";
            quickfindPrice.style.display = "none";
            quickfindBackorder.style.display = "none";
            quickfindDealerBtn.style.display = "block";
            quickViewDetails.classList.add("show");
        }
    }, 200);
}
//USED FOR TRANSITION SO NO JUMPING
function changeDTC() {
    getDTCVars();
    //MAKE SURE WE GOT ELEMENTS
    const checkInterval = setInterval(() => {
        if (quickviewForm && quickfindDealerBtn && quickfindPrice) {
            clearInterval(checkInterval);
            // HIDE/SHOW
            if (quickviewForm != null) {
                quickviewForm.style.display = "none";
            }
            if (quickfindPrice != null) {
                quickfindPrice.style.display = "none";
            }
            if (quickfindBackorder != null) {
                quickfindBackorder.style.display = "none";
            }
            if (quickfindDealerBtn != null) {
                quickfindDealerBtn.style.display = "none";
            }
        }
    }, 200);
}